export default {
  INDEX: "/:user_id?",
  PROCESSING: "/processing/:hash?",
  PROMO: "/promo",
  RESULT: "/result",
  ERROR: "/error",
  PHOTOCHOOSER: "/photochooser",
  START: "/start",
};
